$(".reviewPopup").on("click", function () {
  $("html").css("overflow", "");
  $(".reviewPopup").css("display", "none");
});

$(".reviewPopup .arrow").on('click', function (event) {
  event.stopPropagation();
  const type = $(this).hasClass('right');
  const chilrenNum = $(this).closest('.reviewPopup').find('.imgList img').length;
  var current = matchNum($(this).closest('.reviewPopup').attr('data-current'));

  if (type) {
    current++;
  } else {
    current--;
  }

  if (current < 0) {
    current = 0;
  }
  if (current >= chilrenNum) {
    current = chilrenNum - 1;
  }

  $(this).closest('.reviewPopup').find('.arrow.left').attr('disabled', current == 0);
  $(this).closest('.reviewPopup').find('.arrow.right').attr('disabled', current == chilrenNum - 1);

  $(this).closest('.reviewPopup').attr('data-current', current);

  scrollChangeNum({
    ele: $(this).closest('.reviewPopup').find('.imgList'),
    direction: 'horizontal',
    num: current,
    align: 'center'
  });
})

$('.reviewContainer .reviewBody .reviewList .item .itemBox .reviewContent .imgList img').on('click', function () {
  const index = matchNum($(this).index());
  $("html").css("overflow", "hidden");
  $(this).closest('.item').find(".reviewPopup").attr('data-current', index).css("display", "flex");
  scrollChangeNum({
    ele: $(this).closest('.item').find(".reviewPopup").find('.imgList'),
    direction: 'horizontal',
    num: index,
    align: 'center'
  });
})

function scrollChangeNum (list = {
  ele, direction: 'horizontal', num: 0, align: 'left'
}) {
  // horizontal: 水平; vertical: 垂直
  // 元素宽度
  // var eleSize = list.direction == 'vertical' ? list.ele.height() : list.ele.width();
  // 元素可活动范围
  var eleScroll = list.direction == 'vertical' ? list.ele[0].scrollHeight : list.ele[0].scrollWidth;
  // 第一个子元素大小
  var elechilrenSize = list.direction == 'vertical' ? list.ele.find('>*:first-of-type').outerHeight() : list.ele.find('>*:first-of-type').outerWidth();

  const num = list.ele.find('>*').length;

  // 子元素间距
  var elechilrenSpace = Math.abs((eleScroll - elechilrenSize * num) / (num - 1));

  var pre = (elechilrenSize + elechilrenSpace) * list.num;

  if (list.align == 'center') {
    pre -= ((list.ele.outerWidth() - elechilrenSize) / 2);
  }

  if (list.direction == 'vertical') {
    list.ele.animate({
      scrollTop: pre
    }, {
      duration: 150,
    });
  } else {
    list.ele.animate({
      scrollLeft: pre
    }, {
      duration: 150,
    });
  }
}
